export enum ShipDetailEnum {
  WAREHOUSE = 0,
  LOADED = 1,
  REJECTED = 2,
  REJECTED_CLIENT = 3,
  DELIVERED = 4
}
